module.exports = __webpack_public_path__ + "static/assets/bowltv-logo.c100be7.png";